// QR code desenhado em SVG a partir do texto (aqui, o `otpauth://` do autenticador).
//
// `qrcode-generator` (JavaScript puro, MIT — a mesma do totem) só calcula a matriz; o desenho é
// nosso: um único <path> com um retângulo por FAIXA de módulos escuros de cada linha. Assim não há
// imagem externa nem `data:` gerado, nem `innerHTML` — a CSP padrão do helmet, com que a admin.api
// serve o site, não precisa de exceção nenhuma.
//
// Fundo SEMPRE branco e módulos pretos, mesmo no tema escuro: câmera de celular lê mal QR invertido.
import { useMemo } from 'react';
import qrcode from 'qrcode-generator';

export function QrCode({ texto, tamanho = 200, rotulo }: { texto: string; tamanho?: number; rotulo: string }): JSX.Element {
  const { lado, caminho } = useMemo(() => {
    // Nível M (15% de correção): padrão dos autenticadores; aguenta reflexo na tela.
    const qr = qrcode(0, 'M');
    qr.addData(texto, 'Byte');
    qr.make();
    const n = qr.getModuleCount();
    const partes: string[] = [];
    for (let linha = 0; linha < n; linha++) {
      let inicio = -1;
      for (let coluna = 0; coluna <= n; coluna++) {
        const escuro = coluna < n && qr.isDark(linha, coluna);
        if (escuro && inicio < 0) inicio = coluna;
        if (!escuro && inicio >= 0) {
          partes.push(`M${inicio} ${linha}h${coluna - inicio}v1h-${coluna - inicio}z`);
          inicio = -1;
        }
      }
    }
    return { lado: n, caminho: partes.join('') };
  }, [texto]);

  // Margem de 4 módulos (a "zona quieta" que a especificação do QR exige para a leitura).
  const margem = 4;
  const total = lado + margem * 2;

  return (
    <svg
      role="img"
      aria-label={rotulo}
      width={tamanho}
      height={tamanho}
      viewBox={`${-margem} ${-margem} ${total} ${total}`}
      shapeRendering="crispEdges"
      className="rounded-lg max-w-full h-auto"
    >
      <rect x={-margem} y={-margem} width={total} height={total} fill="#ffffff" />
      <path d={caminho} fill="#000000" />
    </svg>
  );
}
